export default "__VITE_ASSET__CT$GEDlR__"